import { Directive, input, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';

import { distinctUntilChanged, map } from 'rxjs/operators';

import type { FullCandidate } from '@core/candidate-types';

@Directive({
  selector: '[rtKiwiHrIntegrationCardGuard]',
  standalone: true,
})
export class KiwiHrIntegrationCardGuardDirective {
  private readonly vcRef = inject(ViewContainerRef);
  private readonly templateRef = inject<TemplateRef<any>>(TemplateRef);

  public candidate = input.required<FullCandidate>({ alias: 'rtKiwiHrIntegrationCardGuard' });

  constructor() {
    toObservable(this.candidate)
      .pipe(
        map(candidate => candidate.isHired),
        distinctUntilChanged(),
        takeUntilDestroyed(),
      )
      .subscribe(isHired => {
        if (isHired) {
          this.vcRef.createEmbeddedView(this.templateRef);
        } else {
          this.vcRef.clear();
        }
      });
  }
}
